export const toBoolean = (val: number | string) => Boolean(val).valueOf();
